import { render, staticRenderFns } from "./bindphone.vue?vue&type=template&id=1ff332fe&scoped=true"
import script from "./bindphone.vue?vue&type=script&lang=ts"
export * from "./bindphone.vue?vue&type=script&lang=ts"
import style0 from "./bindphone.vue?vue&type=style&index=0&id=1ff332fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff332fe",
  null
  
)

export default component.exports